export const polygonOptions: google.maps.PolygonOptions = {
    fillColor: "blue",
    strokeColor: "blue",
    strokeOpacity: 1,
    strokeWeight: 2
}